import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faJava, 
  faPython, 
  faJs, 
  faNodeJs,
  faDocker,
  faGithub,
  faRust
} from '@fortawesome/free-brands-svg-icons';
import { 
  faDatabase,
  faCogs,
  faTerminal
} from '@fortawesome/free-solid-svg-icons';

const BackendSkills = () => {
  const skills = [
    {
      category: "Languages",
      items: [
        { name: "Java", icon: faJava },
        { name: "Rust", icon: faRust },
        { name: "Python", icon: faPython },
        { name: "TypeScript", icon: faJs },
        { name: "JavaScript", icon: faJs }
      ]
    },
    {
      category: "Frameworks & Runtimes",
      items: [
        { name: "Spring Boot", icon: faJava },
        { name: "Node.js", icon: faNodeJs },
        { name: "Tokio (Rust)", icon: faTerminal }
      ]
    },
    {
      category: "Databases",
      items: [
        { name: "PostgreSQL", icon: faDatabase },
        { name: "MySQL", icon: faDatabase },
        { name: "MongoDB", icon: faDatabase }
      ]
    },
    {
      category: "DevOps & Cloud",
      items: [
        { name: "GitHub Actions", icon: faGithub },
        { name: "Docker", icon: faDocker },
        { name: "REST APIs", icon: faCogs }
      ]
    }
  ];

  return (
    <section id="skills" className="py-20 bg-dark-800">
      <div className="container-max-width section-padding">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="gradient-text">Backend Expertise</span>
          </h2>
          <p className="text-xl text-dark-300 max-w-3xl mx-auto">
            Specialized in building scalable, high-performance backend systems with modern technologies
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {skills.map((skillCategory, categoryIndex) => (
            <div 
              key={categoryIndex}
              className="bg-dark-700 rounded-xl p-6 hover:bg-dark-600 transition-all duration-300 animate-slide-up"
              style={{ animationDelay: `${categoryIndex * 0.1}s` }}
            >
              <h3 className="text-xl font-semibold text-primary-400 mb-6 text-center">
                {skillCategory.category}
              </h3>
              
              <div className="space-y-4">
                {skillCategory.items.map((skill, skillIndex) => (
                  <div 
                    key={skillIndex}
                    className="flex items-center space-x-4 p-3 bg-dark-800 rounded-lg hover:bg-dark-600 transition-colors duration-200"
                  >
                    <FontAwesomeIcon 
                      icon={skill.icon} 
                      className="text-primary-400 text-xl w-6" 
                    />
                    <span className="text-dark-200 font-medium">
                      {skill.name}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Additional Skills */}
        <div className="mt-16 text-center">
          <h3 className="text-2xl font-semibold text-dark-200 mb-8">
            Additional Skills & Tools
          </h3>
          <div className="flex flex-wrap justify-center gap-4">
            {[
              'RESTful APIs', 'GraphQL', 'Microservices', 'Message Queues', 
              'Caching Strategies', 'Load Balancing', 'Security Best Practices',
              'Performance Optimization', 'Code Review', 'Agile Development'
            ].map((skill, index) => (
              <span 
                key={index}
                className="px-4 py-2 bg-dark-700 text-dark-300 rounded-full text-sm font-medium hover:bg-primary-600 hover:text-white transition-all duration-300"
              >
                {skill}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BackendSkills;
